/**
 * List Schema of RotaSla
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {RotaSla} from '@/model/resource/RotaSla'

/* TODO: review generated schema */
export class ListRotaSlaSchema extends Schema {
  readonly name = 'ListRotaSla'

  readonly fieldSet: FieldSet<RotaSla> = {
    pontaSla1: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.pontaSla1?.$id,
      },
    }),
    pontaSla2: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.pontaSla2?.$id,
      },
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    valor: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
